import { c as _c } from "react/compiler-runtime";
import { Box } from '@chakra-ui/react';
import { CompanyProfileForm } from '@src/components/sco/Account/CompanyProfileForm';
import React from 'react';
export const CompanyProfileStep = props => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box borderRadius="3xl" width="full"><CompanyProfileForm /></Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};